var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10971 3H0.642857C0.28782 3 0 2.66421 0 2.25C0 1.83579 0.28782 1.5 0.642857 1.5H9.10971C9.37449 0.62611 10.0888 0 10.9286 0C11.7683 0 12.4827 0.62611 12.7474 1.5H14.3571C14.7122 1.5 15 1.83579 15 2.25C15 2.66421 14.7122 3 14.3571 3H12.7474C12.4827 3.87389 11.7683 4.5 10.9286 4.5C10.0888 4.5 9.37449 3.87389 9.10971 3Z",
    fill: "#4C3CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3571 10.5C14.7122 10.5 15 10.1642 15 9.75C15 9.3358 14.7122 9 14.3571 9H5.89029C5.62551 8.1261 4.91114 7.5 4.07143 7.5C3.23172 7.5 2.51735 8.1261 2.2526 9H0.642857C0.28782 9 0 9.3358 0 9.75C0 10.1642 0.28782 10.5 0.642857 10.5H2.2526C2.51735 11.3739 3.23172 12 4.07143 12C4.91114 12 5.62551 11.3739 5.89029 10.5H14.3571Z",
    fill: "#4C3CA6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c6293f5bbf18ffb81dd84efc11766b1e.svg";
export { ForwardRef as ReactComponent };